let lang = {
    "Chcesz zakończyć nagrywanie?": "Do you want to end the recording?",
    "Po kliknięciu przycisku Nagraj CV odpowiedz na wszystkie pytania. Powodzenia!": "After clicking the Record Resume button, answer all the questions. Good luck!",
    "Uwaga!": "Attention!",
    "Pamięć przeglądarki dla tej domeny jest pełna, nie możemy zapisać wideo lokalnie. Zapisz je na naszym serwerze, aby go nie zgubić. Jeśli nie klikniesz „zapisz”, gdy odświeżysz stronę lub zamkniesz okno nagrywania, wideo może zostać utracone.": "Browser memory for this browser is full, we cannot save video locally. Save recording on our server. If you don't click 'save' after refreshing the page or closing the recording window, your video may be lost.",
    "Save to a server": "Save to server",
    "Ok": "Ok",
    "Proszę czekać, video jest w trakcie przetwarzania.": "Please wait, the video is being processed.",
    "Video CV usunięte": "Video resume removed",
    "Admin": "Admin",
    "GENERAL": "CONTROL PANEL",
    "App": "Statistics",
    "Users": "Users",
    "Vacancies": "Vacancies",
    "Mailing list": "Messages",
    "Video Template": "Video CV",
    "Hi": "Hi",
    "Need help?": "Need help?",
    "Please check our faq": "Please check our faq",
    "FAQ": "FAQ",
    "Welcome": "Welcome",
    "Your candidates are tired of waiting for you - write them something nice!": "In the control panel, you can manage Candidates, Jobs, Messages, Video CV Inquiries.",
    "Go To Users": "User list",
    "Recorded CV": "Recorded Video CV",
    "Active users": "Active users",
    "Total applicants": "Registered Users",
    "Total vacancies": "Job offers",
    "Vacancies closed": "Archival job offers",
    "Settings": "Settings",
    "Profile": "Profile",
    "Home": "Home",
    "Logout": "Logout",
    "general": "General information",
    "resume": "CV",
    "Profile view": "Profile",
    "Dashboard": "Dashboard",
    "User": "User",
    "Account Settings": "Settings",
    "Account": "Account",
    "Update success": "Changes saved",
    "Upload photo": "Add photo",
    "Allowed *.jpeg, *.jpg, *.png, *.gif": "Format *.jpeg, *.jpg, *.png, *.gif",
    "Active Profile": "Active Profile",
    "Username": "First name Last Name",
    "Select city": "City",
    "Data urodzenia": "Date of birth",
    "Email address": "E-mail address",
    "Phone number": "Phone number",
    "Select category": "Category",
    "Password": "Password",
    "About": "About me",
    "Save Changes": "Save Changes",
    "Edit User": "Edit",
    "Video": "Video CV",
    "Link": "Link",
    "Save": "Save",
    "Comment": "Recruiter's comment",
    "Write comment": "Write comment",
    "AboutInfo": "Info",
    "Live at": "City",
    "Category": "Category",
    "Last activity": "Online",
    "Date of Bird": "Date of birth",
    "Resume": "CV",
    "Print": "Print",
    "Zapisz PDF": "Save PDF",
    "Link to video": "Link to Video CV",
    "profile": "CV",
    "video": "Video CV",
    "Video resumes": "Video resume",
    "Zgoda na opublikowanie": "Consent to publish",
    "Tak": "Yes",
    "Brak zgody": "No consent",
    "Utworzono": "Created",
    "Nagrano": "Recorded",
    "Brak nagranego Video CV": "No video CV recorded",
    "User List": "User list",
    "New User": "New",
    "Search user": "Search",
    "Add users": " Send to selected",
    "selected": "selected",
    "Filter list": "Filter",
    "City": "City",
    "Kategoria": "Category",
    "Status": "Status",
    "Video CV": "Video",
    "Employed Through Us": "Employed ",
    "Courses asystent": "Assistant.biz courses",
    "Filter": "Filter",
    "Clear": "Clear",
    "Name": "Name",
    "Last activity": "Online",
    "Aktywny": "Active",
    "Nieaktywny": "Inactive",
    "Video status": "Video CV",
    "Dostępne": "Available",
    "Do usunięcia": "To remove",
    "Usunięte": "Removed",
    "No video": "No video",
    "Recorded": "Recorded",
    "Video recorded": "Recorded",
    "Deleted": "Removed",
    "Need to delete": "To remove",
    "No active": "Inactive",
    "Activee": "Active",
    "Select users to whom you want to send a message": "Select users to whom you want to send a message",
    "Delete": "Delete",
    "Edit": "Edit",
    "View": "Preview",
    "Rows per page": "View",
    "Yes": "Yes",
    "No": "No",
    "Create a new user": "Create a new user",
    "is required": "Required field",
    "New user": " New",
    "Vacancies List": "List of job offers",
    "New Vacancy": "Add job offer",
    "Vacancies": "Job offers",
    "Company": "Company",
    "Mail list": "Sent quantity",
    "Users apply": "Applicants",
    "Active": "Active",
    "Closed": "Archival",
    "MAIL": "Message",
    "Search vacancy...": "Search...",
    "Try checking for typos or using complete words.": "Try checking for types or using complete words.",
    "No results found for": "Not found",
    "Not found": "Not found",
    "Miasto": "City",
    "Message Add": "Add message",
    "Message New": "New message",
    "Action": "Type",
    "Message": "Message",
    "Przykładowy szablon oferty pracy": "Job offer template",
    "Nowa oferta pracy": "New job offer",
    "Message is required": "Message is required",
    "Url": "URL",
    "Write your url": "Wtire URL",
    "Create": "Create",
    "Write your message": "Write your message",
    "Vacancy view": "Job offer view",
    "Dodane": "Added",
    "Wynagrodzenie": "Salary",
    "Rodzaj umowy": "Type of contract",
    "Zatrudnienie": "Employment",
    "Aplikanci": "Applicants",
    "End at ": "Expired ",
    "active": "Active",
    "Opis": "Description",
    "Vacancy new": "Add job offer",
    "Vacancy new bread": "New job offer",
    "umowa o pracę": "Contract of employment",
    "umowa zlecenie": "Contract of mandate",
    "umowa o dzielo": "Contract for specific work",
    "Pełny etat": "Full-time",
    "Niepełny etat": "Part time",
    "Praktyka / staż": "Practice / Internship",
    "Typ umowy": "Type of contract",
    "Wymiar pracy": "Working time",
    "Vacancy is active": "The offer is valid",
    "Write something": "Write ",
    "Mailing list": "Messages",
    "Messages List": "List of messages",
    "Messages": "Messages",
    "New message": "Add",
    "Search message": "Search",
    "Date": "Date",
    "Users send": "Number",
    "Sending": "Sent",
    "Whait for sending": "Processing",
    "Message View": "Message preview",
    "New message": "Add",
    "New": "New",
    "Old": "Delivered",
    "Namei": "Name",
    "Nagraj Video CV": "Record Video CV",
    "Sprawdź status": "Check the status",
    "Zaktualizuj swój profil": "Update your profile",
    "Write your message": "Write your message",
    "Message is required": "Message is required",
    "Create success": "Successfully created",
    "Add users to mail": "Send to selected",
    "Wiadomość wysłana": "Message sent",
    "Video templates List": "Lists of sample questions",
    "Video templates": "Video CV",
    "New Video template": "New list",
    "Base": "Main",
    "Template": "Template",
    "Video template new": "New list",
    "Question": "Question",
    "Time": "Time",
    "Position": "Question number",
    "Write question": "Write question",
    "Write time for question": "Write time for question",
    "Write position 0-100": "Write position 0-100",
    "Add": "Add",
    "sec": "sec",
    "Save All": "Save",
    "Is Base Template?": "Is the main template?",
    "Text": "Treść",
    "Write your text": "Write your text",
    "Text is required": "Text is required",
    "user": "Candidate",
    "MANAGEMENT": "CONTROL PANEL",
    "Hi, Welcome Back": "Welcome to our community!",
    "Get started": "Register",
    "Don’t have an account?": "Don’t have an account?",
    "Login": "Login",
    "Sign in to": "Sign in to Asystent.biz",
    "Enter your details below.": "Enter your details below.",
    "Email is required": "Required field",
    "Password is required": "Required field",
    "Email address": "Email address",
    "Password": "Password",
    "Remember me": "Remember me",
    "Forgot password?": "Forgot password?",
    "Get an account for free.": "Create an account.",
    "Manage the job more effectively": "Search for a new job effectively with Asystent.biz",
    "Already have an account?": "Already have an account?",
    "Register": "Register",
    "By registering, I agree to": "I confirm that I have read",
    "and": "and",
    "przetwarzanie": "I hereby consent to the processing of my personal data",
    "Terms of Service": "Regulations",
    "Privacy Policy": "Privacy Policy",
    "Logini": "Log in",
    "First name": "First name",
    "Last name": "Last name",
    "Phone number": "Phone number",
    "Select category": "Category",
    "Select city": "City",
    "Back": "Back",
    "Please check your email.": "Please check your email.",
    "We have sent a confirmation email to": "We have sent a confirmation email",
    "Request sent successfully": "Sent successfully",
    "Please enter the email address associated with your account and We will email you a link to reset your password.": "Please enter the email address associated with your account and we will email you a link to reset your password.",
    "Forgot your password?": "Forgot your password?",
    "Reset Password": "Reset Password",
    "Email must be a valid email address": "The e-mail address must be a valid address",
    "There is no user record corresponding to this identifier. The user may have been deleted.": "There is no user record corresponding to this email.",
    "Settings": "Settings",
    "Color": "Color",
    "Direction": "Direction",
    "Fullscreen": "Fullscreen",
    "To write your first CV - download the application, log in with your data, confirm your phone number and we can start!": "To add your first CV and be able to take full advantage of our website <a target='blanck' href='/apps'>download the application</a> and confirm your e-mail.",
    "To write your first CV - user": "To be able to take full advantage of our website <a target='blanck' href='/apps'>download the application</a> and confirm your e-mail. Video resume can also be recorded in the browser on your profile <a href='/dashboard/user/profile/video-cv'>HERE</a>.",
    "Exit Fullscreen": "Turn off full screen mode ",
    "Mode": " Mode ",
    "Too Short!": " Too short",
    "Too Long!": " Too long",
    "First name required": " First name required",
    "Last name required":  "Last name required",
    "Email must be a valid email address": "Email must be a valid email address",
    "Password is required": "Required field",
    "Phone is required": "Required field",
    "Register success": "Successfully registered",
    "Login success": "Logged in successfully",
    "Email must be a valid email address": "Email must be a valid email address",
    "Check Status Active": "Looking for a job",
    "Check Profile": " Check Profile",
    "Archive": "Archive",
    "Vacancy": " Job offer",
    "No action": "No action",
    "Write salary": "Write salary",
    "Write ID user": "Write user ID",
    "Go to mail": " Go to e-mail",
    "User added success": "User added successfully",
    "User deleted success": "User deleted successfully",
    "Links": "Links",
    "Additional activity": "Additional activity",
    "Interests": "Interests",
    "Asystent.biz courses": "Asystent.biz courses",
    "Start date": "Start date",
    "todate": "End date",
    "this day": "Now ",
    "Skills": "Skills",
    "Training, courses, certificates": "Training, courses, certificates",
    "Level": "Level",
    "Knowledge of languages": "Knowledge of languages",
    "Work experience": "Work experience",
    "Update photo": "Update photo",
    "Email": "E-mail",
    "Phone": "Phone",
    "Education": "Education",
    "Kierunek": "Field of study",
    "this day": "Now",
    "Specjalizacja": "Specialization",
    "Poziom wykształcenia": "Level of education",
    "Opis stanowiska": "Job description",
    "Szkolenia, kursy, certyfikaty": "Trainings, courses, certificates",
    "Zaktualizuj CV": "Update your CV",
    "Confirm to delete": "Caution!",
    "Confirm to verify": "Caution!",
    "Are you sure to do this?": "Are you sure to remove?",
    "Are you sure to do this video?": "Are you sure to remove?",
    "Are you sure to verify the phone number?": "Are you sure to verify the phone number?",
    "Nie podana": "Not given",
    "Delete video": "Delete video",
    "Verify phone": "Verify phone number",
    "Phone is verified": "Phone number is verified",
    "User video deleted success": "The video has been successfully deleted",
    "my_resume": "Send CV",
    "Use my CV to display on my employer page": "Use the uploaded CV on my profile",
    "Download": "Download",
    "You have not uploaded your resume yet.": "You have not uploaded your CV yet!",
    "ApprowedFileType": "Allowed files to upload - .pdf/.docx",
    "ApprowedFileSize": "The maximum file size should not exceed 10 MB. Your file",
    "CV": "CV",
    
    "Nazwa uczelni/szkoły": "Name of the university / school",
    "Data rozpoczęcia": "Start date",
    "Data zakończenia": "End date",
    "obecnie": "At present",
    "Doświadczenie zawodowe": "Experience",
    "Firma": "Company",
    "Stanowisko": "Position",
    "Znajomość języków": "Knowledge of languages",
    "Język": "Language",
    "Poziom": "Level",
    "Umiejętności": "Skills",
    "Wpisz swoje umiejętności": "Enter your skills",
    "Nazwa": "Name",
    "Data uczestnictwa": "Date of participation",
    "Szkolenia asystent.biz": "Courses asystent.biz",
    "Aktywność dodatkowa": "Additional activity",
    "Wpisz dodatkowe aktywności": "Enter additional activities",
    "Wpisz swoje zainteresowania": "Enter your interests",
    "Zainteresowania": "Interests",
    "Linki": "Links",
    "Adres URL": "URL address",
    "Zapisz zmiany": "Save changes",
    "Activity": "Activity",
    "Application": "Application",

    "Start": "Start",
    "Dla pracodawcy": "For employer",
    "Blog": "Blog",
    "FAQs": "FAQs",
    "Kontakt": "Contact",
    "Oferty pracy": "Job offers",
    "Dołącz do nas": "Join us",
    "Pobierz aplikację": "Download the app",
    "Regulamin korzystania z usług": "Terms and Conditions of use of services",
    "Polityka prywatności": "Privacy policy",
    "Informacja o cookies": "Information about cookies",
    "Jak nagrać video CV": "How to record a video resume",
    "Oferty pracy": "Job offers",
    "O nas": "About us",
    "Szkolenia": "Courses",
    "Informacje zostały zebrane z otwartych źródeł, przetworzone przez naszych specjalistów i opublikowane na stronie. Wszelkie ponowne publikacje są dozwolone, ponieważ dzielimy się wiedzą – a wiedza dla tych, którzy chcą wiedzieć, powinna być dostępna.": "The information has been collected from open sources, processed by our specialists and published on the website. Any republication is allowed because we share knowledge - and knowledge should be available to those who want to know.",
    "Dołącz do społeczności asystent.biz": "Join the community asystent.biz",
    "Z łatwością stwórz swoje video CV online": " Create your video resume online easily",
    "za pomocą naszej aplikacji": "using our app",
    "Wypełnij klasyczne CV i otrzymaj ofertę pracy": "Complete a classic CV and receive a job offer",
    "zgodnie ze swoimi oczekiwaniami": "in accordance with your expectations",
    "© 2021-2022 asystent.biz • All rights reserved": "© 2021-2022 asystent.biz • All rights reserved",
    "Info": "Info",
    "MENU": "MENU",
    "Rozpocznij pracę": "Get started",
    "jako asystent razem z zespołem": "as an assistant with the team",
    "Bezpłatne szkolenia i oferty pracy. Punkt wyjściowy Twojej kariery": "Free courses and job offers. The starting point for your career",
    "Otrzymuj informacje o nowych ofertach bezpośrednio w aplikacji na telefon": "Receive information about new offers directly in the phone app",
    "Pobierz teraz": "Download now",
    "Nauczymy Cię": "We will teach you",
    "być jak najbardziej skutecznym w pracy. Z nami znajdziesz stanowisko asystenta, co daje dobre perspektywy zawodowe.": "how to be most effective at work. With us you will find an Job position, which gives you good career prospects.",
    "Stwórz swoje CV": "Create your CV",
    "W naszym serwisie możesz stworzyć swoje CV, nagrać wideo CV, wziąć udział w bezpłatnych szkoleniach.": "On our website you can create your CV, record a video resume, take part in free courses.",
    "Znajdziemy Ci pracę": "We'll find you a job",
    "U nas proces poszukiwania pracy jest maksymalnie wygodny i efektywny. Dołącz do nas jeszcze dziś.": "Our job search process is as convenient and effective as possible. Join us today!",
    "Dowiedz się, w czym możemy być pomocni": "Find out how we can help you",
    "Dla Kandydata": "For Candidate",
    "Na naszej platformie możesz stworzyć CV, a prosta aplikacja mobilna pomoże Ci nagrać wideo CV, do którego link jest zintegrowany z plikiem klasycznego CV. Taka struktura pozwala przedstawić wyczerpujące informacje o sobie i zoptymalizować proces rekrutacyjny. Osobom poszukującym pracy oferujemy bezpłatne materiały szkoleniowe dotyczące skutecznego wyszukiwania informacji w internecie, a także kursy doskonalące ich umiejętności w zakresie takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Informacje o nowych ofertach pracy pojawią się bezpośrednio na telefonie, a proces rekrutacyjny jest tak prosty, na ile to możliwe. Rejestracja i korzystanie z serwisu asystent.biz są całkowicie bezpłatne dla osób poszukujących pracy.": "On our platform you can create a CV, and a simple mobile app will help you record a video resume, the link to which is integrated into the classic CV file. This structure allows you to present comprehensive information about yourself and optimize the recruitment process. For jobseekers, we offer free training materials on how to effectively search for information on the Internet, as well as courses improving their skills in such programs as: Microsoft Office, Google Calendar, Trello. Information about new job offers will appear directly on your phone, and the recruitment process is as simple as possible. Registration and use of the asystent.biz services are completely free of charge for jobseekers",
    "Powierz nam wybór kandydatów do pracy w Twojej firmie. Z nami poszukiwanie pracowników będzie dla Ciebie proste i skuteczne.  Specjalizujemy się w rekrutacji na stanowiska asystenckie: asystent zarządu, asystent do spraw personalnych, asystent prawnika, asystent biurowy, koordynator biura, office manager, asystentka,  recepcjonistka,  sekretarka, asystent wsparcia biznesu. Gwarantujemy, że  przedstawieni przez nas kandydaci spełnią Twoje oczekiwania i potrzeby. Współpracując z nami oszczędzasz czas. Jak możemy pomóc Tobie? Kompleksowo przeprowadzimy rekrutację kandydatów na wskazane stanowisko, opracujemy treść oferty pracy i opublikujemy na portalach ogłoszeniowych oraz social media, przeprowadzimy pełną selekcję kandydatów, zadzwonimy do wybranych, którzy będą spełniać oczekiwania i umówimy ich na rozmowę kwalifikacyjną.": "Entrust us with the selection of candidates for work in your company. The search for employees will be simple and effective with us. We are not only specialize in recruiting for assistant positions: executive Assistant, HR assistant, assistant lawyer, office manager, office coordinator, assistant, receptionist, secretary, and business support assistant. We guarantee that candidates presented by us will meet your expectations and needs. By cooperating with us, you save time. How can we help you? We will comprehensively recruit candidates for the indicated position, develop the content of the job offer and publish it on advertising portals and social media, conduct a full selection of candidates, call the selected ones who will meet the expectations and arrange them for an interview",
    "JESTEŚ PRACODAWCĄ?": "ARE YOU AN EMPLOYER?",
    "Obszerna baza kandydatów": "Extensive database of candidates",
    "Głównym zasobem firmy są ludzie. Według statystyk, aby znaleźć jednego odpowiedniego pracownika, należy wyselekcjonować i ocenić co najmniej 100 osób. Bierzemy na siebie pełną odpowiedzialność za to zadanie. Zapoznaj się ze szczegółowymi informacjami oraz naszą ofertą.": "People are the company's main resource. According to statistics, in order to find one suitable employee, at least 100 people must be selected and assessed. We take full responsibility for this task. Familiarize yourself with the detailed information and our offer.",
    "Więcej": "More",
    "Dołącz do nas i uzyskaj dostęp do wszystkich usług platformy": "Join us and get access to all platform services",
    "Rejestracja": "Registration",
    "Piękny, nowoczesny i wygodny interfejs użytkownika": "Beautiful, modern and comfortable user interface",
    "Nasza aplikacja": "Our app",
    "Video CV recorder": "Video CV recorder",
    "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania wideo CV w formie odpowiedzi na pytania pracodawcy.": "is a part of the assistant recruiting service and was designed to record a video resume in the form of answering employer's questions.",
    "Konakt": "Contact",
    "Polska": "Poland",
    "ul. Hoża 86/210": "Hoża street 86/210",
    "Warszawa": "Warsaw",
    "Gdzie": "Where",
    "nas": "to find",
    "znaleźć?": "us?",
    "Faqs": "Faqs",
    "Frequently asked questions": "Frequently asked questions",
    "Jak działa serwis asystent.biz?": "How does the asystent.biz work?",
    "faq1": "Our website is a platform that offers modern online recruitment tools, providing effective help and support in establishing contacts between employers and jobseekers. Applying for vacancies is interactive, quick and as easy for the user as possible. <br> <br> We publish job vacancies from employers and applicants receive information about such vacancies by phone in the form of notifications and can view them in our app Asystent.biz. <br> <br> In addition, we offer extensive support to candidates before employment. This includes advanced training, the possibility of creating a CV on our website, as well as the unique opportunity to record a video resume in the form of answers to questions. The use of our system is free of charge for applicants. <br> <br> To take full advantage of our services, candidates must first register and install a mobile application for video CV recording.",
    "Z jakich narzędzi mogę skorzystać w moim Profilu Kandydata?": "What tools can I use in my Candidate Profile?",
    "W sekcji Profil Kandydata możesz wypełnić informację o sobie, stworzyć CV, obejrzeć CV nagrane w aplikacji.": "In the Candidate Profile section, you can fill in information about yourself, create a CV, view the video resume recorded in the app.",
    "Dla kandydatów poszukujących pracy nasz serwis jest całkowicie bezpłatny.": "Our website is completely free for jobseekers.",
    "Przejdź do strony <a href='/apps'>Pobierz aplikację</a> na dole ekranu. Wybierz odpowiedni system operacyjny i zainstaluj aplikację z marketu. Aby potwierdzić rejestrację, będziesz potrzebować aktywnego numeru telefonu i adresu e-mail.": "Go to the <a href='/apps'> Get the app </a> page at the bottom of the screen. Select the appropriate operating system and install the application from the market. You will need an active phone number and email address to confirm your registration.",
    "Wszystko jest bardzo proste! Kliknij „Zapomniałeś hasła?” na stronie lub w aplikacji, wpisz swój adres e-mail i uzyskaj link do zresetowania hasła. W razie pytań śmiało pisz na <a href='mailto:support@asystent.biz'>support@asystent.biz</a>": "Everything is very simple! Click 'Forgot your password?' on the website or in the app, enter your e-mail address and get a link to reset your password. If you have any questions, feel free to write to <a href='mailto:support@asystent.biz'> support@asystent.biz </a>",
    "Dane osobowe podane przez Ciebie przetwarzamy w celu świadczenia usług, takich jak założenie konta oraz prowadzenie rekrutacji na różne stanowiska pracy. W każdym momencie możesz usunąć konto wraz z danymi prywatnymi. Więcej znajdziesz w Polityce Prywatności.": "We process the personal data provided by you in order to provide services, such as setting up an account and recruiting for various jobs. You can delete your account along with your private data at any time. You can find more in the Privacy Policy.",
    "Nasze kursy są całkowicie bezpłatne. Nauczymy Cię sprawnie korzystać z takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Dodatkowo prowadzimy szkolenia skutecznego wyszukiwania informacji w internecie. Aby dołączyć do naszych zajęć online, po prostu przejdź na stronę: SZKOLENIA. Jeżeli masz dodatkowe pytania, pisz na school@asystent.biz.": "Our courses are completely free for our users. We will teach you how to use efficiently such programs as: Microsoft Office, Google Calendar, Trello. In addition, we conduct trainings on how to effectively search for information on the Internet. To join our online Courses, just go to the page: Courses. If you have any additional questions, please write to school@asystent.biz",
    "Nie. W naszym systemie wszystkie oferty pracy pojawiają się w wiadomościach do aplikacji i na koncie osobistym. Jeśli masz dodatkowe pytania dotyczące konkretnego wakatu, napisz na <a href='mailto:asystent@asystent.biz'>asystent@asystent.biz</a>, podając ID oferty pracy.": "No. In our system, all job offers appear in the messages to the application and in the personal account. If you have additional questions about a specific vacancy, write to <a href='mailto:asystent@asystent.biz'> asystent@asystent.biz </a> with the job ID",
    "W swoim profilu w aplikacji lub serwisie internetowym kliknij „Usuń profil” i postępuj zgodnie z instrukcjami. Twój profil i wszystkie dane osobowe zostaną usunięte po potwierdzeniu przez moderatora.": "In your profile in the app or website, click 'Delete Profile' and follow the instructions. Your profile and all personal data will be deleted after confirmation by the moderator.",
    "W jaki sposób mogę wyrejestrować się z serwisu?": "How can I unsubscribe from the website?",
    "Czy mogę wyszukać ofertę pracy w serwisie asystent.biz?": "Can I search for a job on the asystent.biz website?",
    "Czy udział w szkoleniach po wprowadzeniu do zawodu asystenta jest płatny?": "Is participation in training after entering the profession of assistant payable?",
    "Aktualizacja aplikacji do najnowszej wersji.": "Update the application to the latest version.",
    "Pytania bez odpowiedzi – jak mogę skontaktować się z pomocą techniczną?": "Unanswered questions - how can I contact technical support?",
    "Prywatność mojego konta.": "Privacy of my account.",
    "Zgubiłem hasło – jak mogę przywrócić dostęp do mojego konta?": "I have lost my password - how can I restore access to my account?",
    "Jak zainstalować aplikację asystent.biz w telefonie?": "How to install the asystent.biz application on the phone?",
    "Ile zapłacę za korzystanie z systemu, jeśli szukam pracy?": "How much will I pay for use the system if I am looking for a job?",
    "W": "How",
    "czym": "can",
    "możemy": "we",
    "Ci": "help",
    "pomóc?": "you?",
    "News": "News",
    "404 Post not found": "404 Post not found",
    "Recent posts": "Recent posts",
    "Poznaj": "Get to know",
    "nasze": "our",
    "usługi!": "services!",
    "Znajdujemy": "We find",
    "najlepszych kandydatów": "the best",
    "do pracy": "job candidates",
    "ale do zaoferowania mamy o wiele więcej.": "but we have much more to offer.",
    "Powierz nam rekrutację i dobór kandydatów w Twojej firmie.": "Entrust us with the recruitment and selection of candidates in your company.",
    "Poszukiwanie pracowników z nami będzie dla Ciebie proste i skuteczne.": "Searching for employees with us will be simple and effective for you.",
    "Nasi kandydaci spełnią Twoje oczekiwania i potrzeby.": "Our candidates will meet your expectations and needs.",
    "Poznaj naszą ofertę": "Get to know our offer",
    "Specjalizujemy się w rekrutacji na stanowiska asystenckie": "we specialize in recruiting for assistant positions",
    "Asystent zarządu": "Executive Assistant",
    "Asystent personalny": "Personal assistant",
    "Asystent prawnika": "Assistant lawyer",
    "Asystent biurowy, ​Koordynator biura​, ​Office manager​": "Office assistant, Office coordinator, Office manager​",
    "Asystentka​,​ recepcjonistka, ​sekretarka": "Assistant, receptionist, secretary",
    "Asystent wsparcia biznesu": "Business support assistant",
    "Podstawowe warunki współpracy oraz zakres usług": "Basic terms of cooperation and the scope of services",
    "kompleksowe przeprowadzenie rekrutacji kandydatów na wskazane stanowisko": "comprehensive recruitment of candidates for the indicated position",
    "opracowanie treści oferty pracy zgodnie z wymaganiami Pracodawcy": "developing the content of the job offer in accordance with the Employer's requirements",
    "publikacja oferty pracy na portalach ogłoszeniowych i social media": "publication of a job offer on advertising portals and social media",
    "selekcja kandydatów": "selection of candidates",
    "weryfikacja kandydatów pod względem oczekiwanych kwalifikacji": "verification of candidates in terms of the expected qualifications",
    "przeprowadzenie rozmów kwalifikacyjnych telefonicznie i online": "conducting telephone and online interviews",
    "inicjowanie i koordynowanie spotkań pracodawcy z kandydatami": "initiating and coordinating meetings between the employer and candidates",
    "Opłata „Na Start” 600 PLN/netto": "'Start' fee 600 PLN/net",
    "określenie potrzeb rekrutacyjnych Pracodawcy": "determining the recruitment needs of the Employer",
    "analiza bazy Kandydatów": "analysis of the candidate database",
    "publikacja ogłoszeń na portalach i w mediach": "publication of advertisements on portals and in the media",
    "poszukiwania bezpośrednie": "direct search",
    "selekcja, weryfikacja, przedstawienie kandydatur": "selection, verification, presentation of candidates",
    "Chcesz poznać więcej szczegółów? Zapytać o ofertę?": "Do you want to know more details? Ask for an offer?",
    "Śmiało, napisz do nas!": "Go ahead, write to us!",
    "Succes Fee": "Succes Fee",
    "2000 PLN/netto opłata jednorazowa za pozyskanie jednego pracownika, płatne 7 dni po rozpoczęciu pracy przez kandydata": "2000 PLN/net one-time fee for recruiting one employee, payable 7 days after the candidate starts work",
    "Gwarancja 1 miesiąc": "1 months warranty",
    "Jeśli w ciągu miesiąca gwarancyjnego, pracownik zrezygnuje z pracy, lub okaże się nieodpowiedni,": "If during the warranty month the employee resigns from work or proves to be unsuitable,",
    "skieruje do Pracodawcy kolejnego kandydata o podobnym profilu lub zwróci opłatę Succes Fee": "we will refer another candidate with a similar profile to the Employer or return the Succes Fee",
    "Tutaj znajdziesz nasz Regulamin współpracy": "Here you will find our Terms of Cooperation",
    "w kwestiach rekrutacji pracowników": "in matters of recruiting employees",
    "Zamów rekrutację": "Order recruitment",
    "App": "App",
    "IOS": "IOS",
    "Android": "Android",
    "Zainstaluj asystent.biz na iPhone'a": "Install Assistant.biz for iPhone",
    "Zainstaluj asystent.biz na Androida": "Install Assistant.biz for Android",
    "Aplikacja": "App",
    "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania video CV w formie odpowiedzi na pytania pracodawcy. Jest to oficjalną aplikacją mobilną naszego portalu. Lista pytań, na które należy odpowiedzieć, została starannie dobrana przez zespół HR.": "The app is part of the assistant.biz recruitment service and has been designed to record a video resume in the form of answers to the employer's questions. This is the official mobile application of our portal. The list of questions to be answered has been carefully selected by our HR team.",
    "Dla kandydatów poszukujących pracy korzystanie z aplikacja jest bezpłatne.": "The application is free of charge for jobseekers.",
    "Główną zaletą video CV jest to, że możesz nagrać je ponownie. W przeciwieństwie do osobistego spotkania tutaj masz prawo do błędu. Pytania, na które będziesz odpowiadać, pojawią się już w trakcie nagrywania, ale możesz wcześniej się do nich przygotować.": "The main advantage of a video resume is that you can record it again as many times as you want. In contrast to meeting in person, here you have the right to make mistakes. All questions that you will answer will appear during the recording, but you can prepare for them in advance.",
    "Video CV jest już gotowe, co dalej?": "Video resume is ready, what next?",
    "Dalej wszystko jest bardzo proste. Zapisz je i udostępnij do wyszukiwania. W naszym serwisie możesz również stworzyć i zapisać klasyczne tekstowe CV, a link do filmiku znajdzie się bezpośrednio w jego treści, co znacznie ułatwi pracodawcy zapoznanie się z Twoją kandydaturą.": "Then everything is very simple. Save it and make available for search. On our website, you can also create and save a classic text CV, and the link to the video resume will be in its content, which will make it much easier for the employer to read your application.",
    "Dobrze przygotowany film, pewność siebie i poprawne mówienie pomogą Ci wywrzeć pozytywne wrażenie na pracodawcy i zdobyć wymarzoną pracę.": "A well-prepared video resume, self-confidence and correct speech will help you make a positive impression on the employer and get your dream job.",
    "Zrób to, a odniesiesz sukces!": "Do it and you will be successful!",
    "Powodzenia!": "Good luck!",
    "Courses": "Courses",
    "Szkolenia": "Trainings",
    "gratis": "for free",
    "Pracujmy razem i osiągnijmy": "Let's work together and achieve",
    "niesamowite rezultaty.": "amazing results.",
    "Czego chcemy Cię nauczyć?": "What do we want to teach you?",
    "W pracy asystenta ważną rolę odgrywają narzędzia, za pomocą których można sprawniej wykonywać powierzone mu zadania. Wybraliśmy główne obszary, które zalecamy opanować, jeśli planujesz pracować jako personalny asystent. Microsoft Word – edytor dokumentów i tekstów, przeznaczony do tworzenia, przeglądania, edycji i formatowania tekstów, dokumentów biznesowych, a także innych dokumentów. Microsoft Excel – wiodący w branży program do obsługi arkuszy kalkulacyjnych, potężne narzędzie do wizualizacji i analizy danych. Kalendarz Google – usługa planowania spotkań, wydarzeń i spraw. Umożliwia ustawianie przypomnień i godzin spotkań, pozwala na zapraszanie innych uczestników za pomocą powiadomień e-mail. Trello – oprogramowanie do zarządzania projektami w chmurze dla małych zespołów. Może pomóc w zorganizowaniu wszystkiego: od etapów dużego projektu po małe zadania. Skuteczne wyszukiwanie informacji w internecie – dla większości użytkowników nie jest już tajemnicą, że w internecie można znaleźć prawie każdą informację. Ale niewiele osób wie, jak poprawnie ją wyszukiwać. Nauczymy Cię tego.": "An important role in the assistant's work is played by tools with which you can perform the assigned tasks more efficiently. We have selected the main areas that we recommend if you plan to work as a personal assistant. Microsoft Word - document and text editor, designed for creating, viewing, editing and formatting texts, business documents, and other documents. Microsoft Excel - Industry-leading spreadsheet program, powerful data visualization and analysis tool. Google Calendar - meeting, event and case scheduling service. It allows you to set reminders and meeting times, and allows you to invite other participants via e-mail notifications. Trello - Cloud project management software for small teams. It can help you organize everything from the stages of a large project to small tasks. Effective searching for information on the Internet - it is no longer a secret for most users that almost any information can be found on the Internet. But few people know how to search for it correctly. We will teach you this.",
    "Dołącz do naszych kursów": "Join our courses",
    "Link has no active": "The link is inactive",
    "Status: Oferta pracy wygasła -": "Status: Job offer has expired -",
    "Dodana": "Added",
    "404 Przepraszamy, strony nie znaleziono": "404 Sorry, page not found",
    "Przepraszamy, strony nie znaleziono!": "Sorry, page not found!",
    "Nie mogliśmy znaleźć strony, której szukasz. Być może błędnie wpisałeś adres URL?": "We couldn't find the page you were looking for. Perhaps you entered the URL incorrectly?",
    "Sprawdź pisownię i spróbuj ponownie.": "Check the spelling and try again.",
    "Go to Home": "Go to Home",
    "500 wewnętrzny błąd serwera": "500 internal server error",
    "Wystąpił błąd, spróbuj ponownie później.": "An error has occurred, please try again later.",
    "": "",
}

export default lang